import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../diccionarios/comisionesModulo';

@Injectable({
  providedIn: 'root'
})
export class VendedoresRelacionadosService {

  diccionarioUrl: any;
  urlMaestros: string;
  urlComisiones: string;
  constructor(
    private commom: CommonService,
    private utilServices: UtilsService
  ) {
    this.urlMaestros = this.utilServices.getDatosMaestros();
    this.urlComisiones = this.utilServices.getComisiones();
    this.diccionarioUrl = comisionesModulo.url.vendedoresRelacionados;
  }

  getTodo(id) {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.filtrar + id);
  }

  save(innObj: any) {
    console.log("saveTipoDeVendedore", innObj)
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.crear, innObj);
  }

  update(innObj: any) {
    return this.commom.peticionPutConHeader(this.urlComisiones + this.diccionarioUrl.editar, innObj);
  }

  delete(id: string) {
    return this.commom.peticionDeleteConHeader(this.urlComisiones + this.diccionarioUrl.eliminar + `${id}`);
  }

  vendedor(id: string) {
    return this.commom.peticionGetConHeader(this.urlMaestros + this.diccionarioUrl.getVendedor + `${id}`);
  }

}
